import React from 'react';
import style from './WitsmlList.module.css';
import { TabItem } from './constants';

type Props = {
  list: TabItem[];
};
export default function WitsmlList({ list }: Props) {
  return (
    <div className={style.list}>
      {list.map((item, index) => (
        <div key={index} className={style.item}>
          <span className={style.icon}>
            <item.icon />
          </span>
          <div>
            {'isInnerica' in item && item.isInnerica
              ? item.text.split('INNERICA').map((part, partIndex) => (
                  <React.Fragment key={partIndex}>
                    {partIndex > 0 && <span className={style.bold}>INNERICA</span>}
                    {part}
                  </React.Fragment>
                ))
              : item.text}
          </div>
        </div>
      ))}
    </div>
  );
}
